import React from "react";
import { Link } from "react-router-dom";
import {
  FiArrowUpRight,
  FiAward,
  FiChevronRight,
  FiTool,
} from "react-icons/fi";
import { CalibrationPointIcon } from "../utils/calibrationIcons";
import { getServiceBySlug, serviceCategories } from "../data/serviceData";

const gridServices = serviceCategories.filter((service) => service.items);
const forceAndHardnessService = getServiceBySlug("force-hardness-calibration");

const InstrumentGrid = ({ items }) => (
  <ul className="services-instrument-grid">
    {items.map((item, index) => (
      <li key={`${item}-${index}`}>
        <span className="services-instrument-icon">
          <CalibrationPointIcon label={item} />
        </span>
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const ForceAndHardness = () => {
  if (!forceAndHardnessService) {
    return null;
  }

  return (
    <section className="services-force-section">
      <div className="services-catalog-shell">
        <header className="services-force-header">
          <div>
            <span className="services-catalog-kicker">
              <FiTool aria-hidden="true" />
              Specialist capability
            </span>
            <h2>{forceAndHardnessService.name}</h2>
            <p>{forceAndHardnessService.intro}</p>
          </div>
          <Link to={`/services/${forceAndHardnessService.slug}`}>
            View service details
            <FiArrowUpRight aria-hidden="true" />
          </Link>
        </header>

        <div className="services-table-stack">
          {forceAndHardnessService.sections.map((section, sectionIndex) => (
            <article key={section.title} className="services-table-panel">
              <div className="services-table-heading">
                <span>{String(sectionIndex + 1).padStart(2, "0")}</span>
                <h3>{section.title}</h3>
              </div>
              <div className="services-table-scroll">
                <table>
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Parameter / Measured Quantity / Device</th>
                      <th>Range</th>
                    </tr>
                  </thead>
                  <tbody>
                    {section.entries.map((entry, index) => (
                      <tr key={`${section.title}-${entry.parameter}`}>
                        <td>{String(index + 1).padStart(2, "0")}</td>
                        <td>{entry.parameter}</td>
                        <td>{entry.range}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

const Services = () => (
  <main className="services-catalog-page">
    <header
      className="services-catalog-hero"
      style={{ backgroundImage: 'url("/img/product.jpeg")' }}
    >
      <div className="services-catalog-hero-overlay" />
      <div className="services-catalog-hero-copy">
        <nav aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <FiChevronRight aria-hidden="true" />
          <span>Services</span>
        </nav>
        <span className="services-catalog-kicker is-dark">
          <FiAward aria-hidden="true" />
          Accredited calibration capabilities
        </span>
        <h1>Calibration services engineered around measurement confidence</h1>
        <p>
          Explore our electrical, dimensional, pressure, mass, volume, thermal,
          force and hardness calibration capabilities.
        </p>
      </div>
    </header>

    <section className="services-catalog-intro">
      <div className="services-catalog-shell">
        <span className="services-catalog-kicker">
          <FiTool aria-hidden="true" />
          Instrument coverage
        </span>
        <h2>One accredited partner across essential calibration disciplines</h2>
        <p>
          Select a discipline to review its complete instrument coverage and
          dedicated service information.
        </p>
      </div>
    </section>

    <div className="services-catalog-flow">
      {gridServices.map((service, serviceIndex) => (
        <section
          key={service.slug}
          className={`services-catalog-section ${
            serviceIndex % 2 ? "is-alt" : ""
          }`}
        >
          <div className="services-catalog-shell services-catalog-layout">
            <header className="services-catalog-copy">
              <span className="services-catalog-number" aria-hidden="true">
                {String(serviceIndex + 1).padStart(2, "0")}
              </span>
              <span className="services-catalog-icon">
                <CalibrationPointIcon label={service.name} />
              </span>
              <p className="services-catalog-eyebrow">Calibration discipline</p>
              <h2>{service.name}</h2>
              <p>{
                Array.isArray(service.intro) ? service.intro[0] : service.intro
              }</p>
              <Link to={`/services/${service.slug}`}>
                Explore {service.shortName}
                <FiArrowUpRight aria-hidden="true" />
              </Link>
            </header>
            <div className="services-catalog-instruments">
              <div className="services-catalog-instruments-head">
                <h3>Instrument coverage</h3>
                <span>{service.items.length} capabilities</span>
              </div>
              <InstrumentGrid items={service.items} />
            </div>
          </div>
        </section>
      ))}
    </div>

    <ForceAndHardness />
  </main>
);

export default Services;
